import { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import SuspendCompanyServicesForm from './suspendCompanyServicesForm';

class SuspendCompanyServices extends Component{
    state = {
        componentSteps: [
            {
                title: 'Select Company',
                content: <GetInfo apiLink='companies/getOneCompany/' isAllCompanies />,
                id: 0,
            }, {
                title: 'Service Suspension',
                content: <SuspendCompanyServicesForm />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default SuspendCompanyServices
